export default __webpack_public_path__ + "static/media/January2012.b9782f5b.png";